<template lang="pug">
.qmodii-modal-content
  VDialog(v-model="modal3", max-width="400px")
    VCard
      VCardText
        VLayout(align-space-around, justify-center, column)
          VFlex(xs12)
            span {{ $t('labels.ohlcmsg') }}
      VCardActions
        VBtn(color="blue darken-1", flat, @click.native="modal3 = false") {{ $t('buttons.close') }}
  VDialog(v-model="modal2", max-width="500px", v-if="acitve")
    VCard
      VCardTitle
        span.headline {{ acitve.event }}
      VCardText
        VLayout(align-space-around, justify-center, column)
          VFlex.IE-FlexAuto(xs12, v-if="acitve.params.index")
            VSelect(
              v-bind:label="$t('labels.base_on')",
              attach,
              :items="options",
              v-model="acitve.params.index",
              dense
            )
          VFlex.IE-FlexAuto(
            xs12,
            v-for="(item, key, index) in acitve.params",
            v-if="key !== 'index'"
          :key="index"
          )
            VTextField(
            v-if="types[key]"
              v-bind:label="types[key].label",
              :mask="types[key].mask",
              v-model.number="acitve.params[key]"
            )
          VFlex.IE-FlexAuto(xs12)
            span(style="color: rgba(0,0,0,0.54)") {{ $t('labels.color') }}
            //- input.qmodii-input.qmodii-input-color.qmodii-text-c(type='color', v-model="activeColor")
            .qmod-color-box-cont
              span.qmod-color-box(
                v-for="(color, idx) in this.getColors",
                @click="selectedColor = idx",
                v-bind:style="{ backgroundColor: color }",
                v-bind:class="{ 'qmod-color-box-active': selectedColor == idx }"
              )
      VCardActions
        VBtn(color="blue darken-1", flat, @click.native="modal2 = false") {{ $t('buttons.close') }}
        VSpacer
        VBtn(color="green darken-1", flat, @click.native="addIndc()") {{ $t('labels.add_indicator') }}
  VCard
    VCardTitle
      span.headline {{ $t('labels.indicators') }}
    VCardText
      VTabs(v-model="model")
        VTab {{ $t('labels.overlay') }}
        VTab {{ $t('labels.lower') }}
        VTab {{ $t('labels.active') }}
      VTabsItems(v-model="model", vertical)
        VTabItem
          VList(two-line, dense)
            VListTile(v-for="item in list", :key="item.event")
              VListTileContent
                VListTileTitle {{ item.name }}
                VListTileSubTitle {{ item.desc }}
              VListTileAction
                VBtn(color="primary", small, @click="setActive(item)")
                  | {{ $t('labels.add') }}
        VTabItem
          VList(two-line, dense)
            VListTile(v-for="item in lowerlist", :key="item.event")
              VListTileContent
                VListTileTitle {{ item.name }}
                VListTileSubTitle {{ item.desc }}
              VListTileAction
                VBtn(color="primary", small, @click="setActive(item)")
                  | {{ $t('labels.add') }}
        VTabItem
          VList(two-line, dense)
            VListTile(v-for="item in activelist", :key="item.keyID")
              VListTileContent
                VListTileTitle {{ item.name }} | {{ convertParams(item.params) }}
                VListTileSubTitle {{ item.desc }}
              VListTileAction
                VBtn(color="red", small, @click="removeInd(item)")
                  | {{ $t('labels.remove') }}
    VCardActions
      VBtn(color="blue darken-1", flat, @click.native="closeModal()") {{ $t('buttons.close') }}
</template>

<script>
import {
  VDialog,
  VTab,
  VTabs,
  VTabsItems,
  VTabItem,
  VExpansionPanel,
  VExpansionPanelContent,
  VList,
  VSubheader,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAction,
  VLayout,
  VFlex,
  VTextField,
  VSelect,
  VIcon,
  VBtn,
  VSpacer,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
} from "vuetify/lib";
import ToggleButton from "@LAYOUT/ToggleButton";

export default {
  name: "indicatorModal",
  components: {
    VDialog,
    VTabsItems,
    VTabItem,
    VTab,
    VTabs,
    VExpansionPanel,
    VExpansionPanelContent,
    VList,
    VSubheader,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAction,
    VLayout,
    VFlex,
    VTextField,
    VSelect,
    VIcon,
    ToggleButton,
    VBtn,
    VSpacer,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
  },
  props: ["enabled", "list", "lowerlist", "chartype", "activelist", "mutex"],
  data() {
    return {
      types: {
        shortPeriod: {
          label: this.$t('labels.short_period'), //
          mask: "###",
        },
        longPeriod: {
          label: this.$t('labels.long_period'), //
          mask: "###",
        },
          signalPeriod: {
          label: this.$t('labels.signal_period'), //
          mask: "###",
        },
        standardDeviation: {
          label: this.$t('labels.standard_deviation'),
          mask: "###",
        },
        ranges: {
          label: this.$t('labels.ranges'),
          mask: "###",
        },
        deviation: {
          label: this.$t('labels.Deviation'),
          mask: "###",
        },
        highIndex: {
          label: this.$t('labels.High_Index'),
          mask: "###",
        },
        lowIndex: {
          label: this.$t('labels.Low_Index'),
          mask: "###",
        },
        bottomBand: {
          label: this.$t('labels.Bottom_Band'),
          mask: "#.###",
        },
        topBand: {
          label: this.$t('labels.Top_Band'),
          mask: "#.###",
        },
        increment: {
          label: this.$t('labels.increment'),
          mask: "#.###",
        },
        period: {
          label: this.$t("labels.period"),
          mask: "###",
        },
        maxAccelerationFactor: {
          label: this.$t("labels.Max_Acceleration_Factor"),
          mask: "#.###",
        },
        initialAccelerationFactor: {
          label: this.$t("labels.Initial_Acceleration_Factor"),
          mask: "#.###",
        },
      },
      modal3: false,
      modal2: false,
      model: 0,
      selectedColor: 0,
      activeColor: "#0a64a6",
      title: "Events",
      acitve: false,
      isEnabled: this.enabled,
      options: [
        {
          text: this.$t("labels.open"),
          value: 0,
        },
        {
          text: this.$t("labels.high"),
          value: 1,
        },
        {
          text: this.$t("labels.low"),
          value: 2,
        },
        {
          text: this.$t("labels.close"),
          value: 3,
        },
      ],
    };
  },
  methods: {
      convertParams(incomingParams) {
          let newArray = {};
          for (let [key, value] of Object.entries(incomingParams)) {
              let newKey = this.$t(`labels.${key}`)
              newArray[newKey] = value;
          }

          return JSON.stringify(newArray)
          //JSON.stringify(item.params)
      },
    closeModal() {
        this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
      // this.$store.commit("AdvancedChart/SET_MODAL_ISOPEN", false);
    },
    //
    removeInd(indicator) {
      this.$emit("delInd", indicator);
      this.$emit("showmodal");
    },
    addIndc() {
      this.acitve.color = this.getColors[this.selectedColor];
      this.$emit("addInd", this.acitve);
      this.closeModal();
    },
    setActive(item) {
      if (this.chartype == "line" || this.chartype == "area") {
        if (item.needsOHLC) {
          this.modal3 = true;
          return;
        }

        // return;
      }

        this.acitve = item;
      this.modal2 = true;

    },
    toggleEnabled() {
      this.isEnabled = !this.isEnabled;
    },
  },
  computed: {
    getEnabled() {
      return this.isEnabled ? "On" : "Off";
    },
    getColors() {
       return this.$store.state[`AdvancedChart_${this.mutex}`].seriesColors;
      // return this.$store.getters["AdvancedChart/getSeriesColors"];
    },
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmodii-modal-content
  width 100%
.qmod-color-box-cont
  display flex
  // justify-content space-between
  margin-top 5px
  .qmod-color-box
    max-width 30px
    height 30px
    flex auto
    cursor pointer
    text-align center
    color #fff
    margin-right 17px
    &.qmod-color-box-active
      border 1px solid black
      &:after
        position relative
        top 3px
        content '✔'
.qmodii-select.qmodii-input-color, .qmodii-input.qmodii-input-color
  width 100%
  max-width 100%
  height 30px
.qmodii-active-list-item
  &.qmodii-modal-btn-bar
    margin-top 10px
.qmodii-list-item, .qmodii-active-list-item
  border-bottom 1px solid #e4e4e4
  margin 2px 0
  display flex
  align-items center
  .qmodii-c-mag
    margin-left 2px
    .qmodii-btn
      border-radius 50%
      padding 8px
      transition background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
      &.qmodii-active, &:hover
        border 2px solid black
  .qmodii-marg-left
    margin-left auto
  .qmodii-marg-right
    flex 1
    margin-right auto
  .qmodii-marg-auto
    margin auto
.IE-FlexAuto
  flex-basis auto !important
</style>
